import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-search\">\n<path d=\"M15.4807 8.61544C15.4807 12.4071 12.4069 15.4809 8.61533 15.4809C4.82372 15.4809 1.75 12.4071 1.75 8.61544C1.75 4.82375 4.82372 1.75 8.61533 1.75C12.4069 1.75 15.4807 4.82375 15.4807 8.61544Z\" stroke=\"#D9D4D6\" stroke-width=\"1.5\" />\n<path d=\"M13 13.0005L19.0002 19.0003\" stroke=\"#D9D4D6\" stroke-width=\"1.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol